<template>
    <div>
        <b-btn class="btn btn-sm btn-secondary new-jobsite" title="Add New Jobsite" v-if="showButton" v-on:click="openJobsiteModel=true">
            <i class="fa fa-plus-circle"></i>
        </b-btn>

        <!-- Modal Component -->
        <b-modal v-model="openJobsiteModel" title="New Jobsite" size="lg" ok-title="Create Jobsite" ok-variant="success" no-fade @show="getJobsite" @hide="handleHide" @hidden="handleHidden" @ok="handleOk" ref="jobsiteModal" :no-close-on-backdrop="true" scrollable>

            <div v-bind:class="{ 'form-group': true, 'has-error': errors.JobsiteNumber }" class="row">
                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.JobsiteNumber}">
                    Jobsite#: <i class="fa fa-asterisk text-danger"></i>
                </label>
                <div class="col-sm-8">
                    <input type="text" name="JobsiteNumber" v-model="jobsite.JobsiteNumber" :class="{'form-control': true, 'is-invalid': errors.JobsiteNumber}" placeholder="Enter Jobsite Number" />
                    <span v-if="errors.JobsiteNumber" class="text-danger">
                        <span v-for="error in errors.JobsiteNumber">{{ error }}</span>
                    </span>
                </div>
            </div>
            <div v-bind:class="{ 'form-group': true, 'has-error': errors.JobsiteName }" class="row">
                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.JobsiteName}">Jobsite Name: <i class="fa fa-asterisk text-danger"></i></label>
                <div class="col-sm-8">
                    <input type="text" name="JobsiteName" v-model="jobsite.JobsiteName" :class="{'form-control': true, 'is-invalid': errors.JobsiteName}" placeholder="Enter Jobsite Name (Required)" />
                    <span v-if="errors.JobsiteName" class="text-danger">
                        <span v-for="error in errors.JobsiteName">{{ error }}</span>
                    </span>
                </div>
            </div>
            <div v-bind:class="{ 'form-group': true, 'has-error': errors.DivisionId }" class="row">
                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.DivisionId}">Division: <i class="fa fa-asterisk text-danger"></i></label>
                <div class="col-sm-8">
                    <b-form-select v-model="jobsite.DivisionId" :options="divisionOptions" :class="{'is-invalid': errors.DivisionId}" />

                    <span v-if="errors.DivisionId" class="text-danger">
                        <span v-for="error in errors.DivisionId">{{ error }}</span>
                    </span>
                </div>
            </div>
            <div v-bind:class="{ 'form-group': true, 'has-error': errors.client_id }" class="row">
                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.client_id}">Client:</label>
                <div class="col-sm-8">
                    <b-form-select v-model="jobsite.client_id" :options="clientOptions" :class="{'is-invalid': errors.client_id}" />

                    <span v-if="errors.client_id" class="text-danger">
                        <span v-for="error in errors.client_id">{{ error }}</span>
                    </span>
                </div>
            </div>

        </b-modal>
    </div>
</template>

<script>
    export default {

        props: {
            showButton: {
                type: Boolean,
                default: true,
            },
        },

        data: function() {
            return {
                loading: true,
                jobsite: {},
                openJobsiteModel: false,
                errors: {},
                clients: [],
                divisions: [],
            }
        },

        computed: {
            clientOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Client --'}];

                //Loop
                for(var i = 0; i < this.clients.length; i++)
                {
                    options.push({value: this.clients[i].client_id, text: this.clients[i].client_name});
                }

                //Send options
                return options;
            },

            divisionOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Division --'}];

                //Loop
                for(var i = 0; i < this.divisions.length; i++)
                {
                    options.push({value: this.divisions[i].DivisionId, text: (this.divisions[i].division_code + ' - ' + this.divisions[i].DivisionName)});
                }

                //Send options
                return options;
            },
        },

        methods: {

            show(){
                this.openJobsiteModel = true;
            },

            handleHide(bvEvt){
                //debugging
                if(this.$root.debug)
                {
                    //console.log('Hiding Modal');
                }
            },

            handleHidden(bvEvt){
                //Reset the values
                this.jobsite = {};
                this.errors = {};
            },

            handleOk: function(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Show loading?

               //Do it
               this.saveJobsite();
            },

            getJobsite(){
                //Send it
                this.$http
                //.get('employees/edit' + (this.employee.EmployeeId ? '/' + this.employee.EmployeeId : ''))
                .get('jobsites/edit')
                .then(response => {
                    //Setter
                    this.jobsite = response.data.jobsite;
                    this.divisions = response.data.divisionCollection;
                    this.clients = response.data.clients;
                })
                .catch(error => {

                });
            },

            saveJobsite() {
                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('jobsites/edit', this.jobsite)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Jobsite Saved');

                    //Close the modal
                    this.$refs.jobsiteModal.hide();

                    //Return to main list?
                    this.$emit('jobsiteCreated', response.data);

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                    this.$emit('employeeFailed', null);
                })
            },
        },

        mounted() {
            //SEt the height
            //console.log(this.$refs.jobsiteModal.$refs);
            //this.$refs.jobsiteModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';
        }
    }
</script>

<style scoped>
    .new-jobsite {
        position: absolute;
        top: 0;
        right: -28px;
        height: 38px;
    }
</style>